import markItemsAsReadBasedOnItemIds from '../../helpers/markItemsAsReadBasedOnItemIds';
import { TableView } from 'owa-mail-list-store';
import { action } from 'satcheljs/lib/legacy';
import { InstrumentationContext } from 'owa-mail-store';
import { ActionSource } from 'owa-mail-store';

export default action('markItemAsReadFromReadingPane')(function markItemAsReadFromReadingPane(
    itemId: string,
    tableView: TableView,
    isReadValue: boolean,
    instrumentationContexts: InstrumentationContext[],
    actionSource: ActionSource
) {
    markItemsAsReadBasedOnItemIds(
        tableView,
        [itemId],
        isReadValue,
        true /* isExplicit */,
        actionSource,
        instrumentationContexts
    );
});
